var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-wrap ma-1 pb-2"},_vm._l((_vm.owned),function(item,key){return _c('item',{key:key,staticClass:"ma-1",attrs:{"name":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }